import script from "./SalesRegisterTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesRegisterTable.vue?vue&type=script&setup=true&lang=js"

import "./SalesRegisterTable.vue?vue&type=style&index=0&id=66e1c4ef&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e1c4ef"]])

export default __exports__